/**
 * Do not edit directly, use `yarn generate:icons`
 */

import React from 'react';
import {Base} from '../../../Internal/Base/';

const pathStrings = {
  24: [
    'M21.009 3A2.996 2.996 0 0124 6.005V9.78l-.757.19c-.11.026-.345.134-.584.344-.412.36-.659.885-.659 1.685s.247 1.325.659 1.685c.24.21.475.318.584.345l.757.19v3.775A2.997 2.997 0 0121.009 21H2.99A2.996 2.996 0 010 17.995V14.22l.757-.19c.11-.026.345-.134.584-.344C1.753 13.325 2 12.8 2 12s-.247-1.325-.659-1.685c-.24-.21-.475-.318-.584-.345L0 9.78V6.006A2.997 2.997 0 012.991 3H21.01zm0 2H2.99A.997.997 0 002 6.005V8.34c.213.121.436.275.659.47C3.497 9.543 4 10.613 4 12s-.503 2.457-1.341 3.19a4.013 4.013 0 01-.659.47v2.335A.996.996 0 002.991 19H21.01a.997.997 0 00.991-1.005V15.66a4.013 4.013 0 01-.659-.47C20.503 14.457 20 13.387 20 12s.503-2.457 1.341-3.19c.223-.195.446-.349.659-.47V6.005A.996.996 0 0021.009 5zm-7.945 2.192l1.583.656-3.71 8.96-1.584-.656 3.71-8.96zm2.365 5.665a1.715 1.715 0 11-.002 3.43 1.715 1.715 0 01.002-3.43zM8.57 7.714a1.715 1.715 0 110 3.43 1.715 1.715 0 010-3.43z',
  ],
};

type Props = {size: keyof typeof pathStrings} & Omit<
  React.SVGAttributes<HTMLOrSVGElement>,
  'width' | 'height' | 'viewBox'
>;

export const IconVoucher = ({
  size,
  className,
  ...rest
}: Props): React.ReactElement<React.ReactSVGElement> => {
  const paths = pathStrings[size].map((d: string, i: number) => (
    <path key={String(i)} d={d} fillRule="evenodd" />
  ));

  return (
    <Base
      as="svg"
      height={size}
      width={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      // Because viewPort(height + width) and viewBox might not have the same ratio
      // `preserveAspectRatio` indicates wether we should force a uniform scaling.
      // Therefore, `xMidYMid` centers the viewBox region within the viewPort region,
      // and `meet` scales the graphic until it meets the height and width of our viewPort.
      // More details here, https://www.digitalocean.com/community/tutorials/svg-preserve-aspect-ratio
      preserveAspectRatio="xMidYMid meet"
      fill="currentColor"
      {...rest}
    >
      {paths}
    </Base>
  );
};

IconVoucher.displayName = 'IconVoucher';
